import { useQuery } from '@tanstack/react-query';
import { api, queryKeys, STALE_TIME } from '@/lib/api';
import { useEntitlements } from '@/lib/entitlements';
import type { ModuleId } from '@/lib/modules';

/**
 * El número al lado de un módulo en el menú: lo que está esperando a alguien.
 *
 * Hoy uno solo, «Sin atender» de Escalamiento Humano, porque es el único módulo
 * cuya pantalla es una cola que alguien tiene que vaciar: el número dice si hay
 * que ir. Se pide con la MISMA clave que los conteos de la lista, así que
 * resolver un caso lo baja en el menú en el mismo momento.
 */
export function useContadoresDelMenu(): Partial<Record<ModuleId, number>> {
  const { tenant, hasModule } = useEntitlements();
  const conEscalamiento = hasModule('escalation');
  const query = useQuery({
    queryKey: [...queryKeys.escalamientos(tenant.id), 'conteos'],
    queryFn: () => api.escalamientos.conteos(tenant.id),
    enabled: conEscalamiento,
    staleTime: STALE_TIME.realtime,
    refetchInterval: 60_000,
  });
  const sinAtender = query.data?.porVista.sin_atender ?? 0;
  return conEscalamiento && sinAtender > 0 ? { escalation: sinAtender } : {};
}
